import { useEffect } from 'react';
import { AnimationController } from './AnimationController';
import { bindAnimationDOM } from './bindAnimationDOM';
import { AnimationModeConfig } from './AnimationTypes';
import { notify } from '@/utils';

export function useAnimationEngine(config: {
    uniqueId: number;
    frames: any[];
    subDir: string;
    activePlaybackMode: AnimationModeConfig;
    deviceProfile: any;
    w: number;
    h: number;
    alignmentIndex?: number;
}) {
    const {
        uniqueId,
        frames,
        subDir,
        activePlaybackMode,
        deviceProfile,
        w,
        h,
    } = config;

    useEffect(() => {
        if (!uniqueId || frames.length === 0) return;

        if (deviceProfile?.lowBattery) {
            notify.warning(
                'Akkustand kritisch niedrig. Die flüssige Wiedergabe der Zeitraffer-Animation wurde zum Energiesparen angehalten.',
            );
            return;
        }

        const controller = new AnimationController({
            uniqueId,
            frames,
            subDir,
            activePlaybackMode,
            deviceProfile,
            w,
            h,
            alignmentIndex: config.alignmentIndex,
        });

        const unbindNativeDOM = bindAnimationDOM(
            controller,
            uniqueId,
            activePlaybackMode,
        );

        return () => {
            unbindNativeDOM();
        };
    }, [uniqueId, frames, subDir, activePlaybackMode, deviceProfile, w, h]);
}
